import React from 'react'
import Header from '../Header'
import Sidebar from '../Sidebar'
import { Link } from 'react-router-dom'
import FeatherIcon from 'feather-icons-react/build/FeatherIcon'
const PateintDocument = () => {
  return (
    <>
    <Header/>
    <Sidebar/>
    <div className='page-wrapper'>
      <div className='content'>
      <div className="page-header">
            <div className="row">
              <div className="col-sm-42">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">
                    My Document
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className='row'>
          <div className='col-12 col-md-12 col-lg-12 col-xl-6'>
            <div className='card '>
              <div className='card-body'>
                <div >
                  <h4 className='mb-4'>VC Health Information Privacy Disclosure Form</h4>
                  <a href='/VC_health.doc' download="vcdoctor_health.doc" className='btn btn-primary'>Download form</a>
                </div>
              </div>
            </div>
            </div>
            <div className='col-12 col-md-12 col-lg-12 col-xl-6'>
            <div className='card '>
              <div className='card-body'>
                <div >
                  <h4 className='mb-4'>VC Patient Prescriptions Records Release Form</h4>
                  <a href='/VC_pateint' download="vcdoctor_pateint.doc" className='btn btn-primary'>Download form</a>
                </div>
              </div>
            </div>
            </div>
           
          
          </div>
          
      </div>
    </div>
    </>
  )
}

export default PateintDocument
